// dependencies
import { List, Map, fromJS } from "immutable";
import { CreateProcess } from "redux-process";

// utils
import get from "../../utils/GetNested";
import serializeObject from "../../utils/SerializeObject";

/**
 * Will find if a user is an admin. Returns a boolean.
 * @param {string} userID - id of the user
 */
export const GetUserIsAdmin = CreateProcess({
	method: "GET",
	name: "GetUserIsAdmin",
	type: "USERS:GETONE.ADMIN",

	request: () => ({
		url: "/api/user/admin/",
	}),

	success: (response) => fromJS(response.data),
});

/**
 * Will find if a user is an admin of a group. Returns a boolean.
 *
 * @param {string} userID - id of the user
 * @param {string} groupID - id of the group
 */
export const GetUserIsGroupAdmin = CreateProcess({
	method: "GET",
	name: "GetUserIsGroupAdmin",
	type: "USERS:GETONE.GROUPADMIN",

	request: (props) => ({
		url: `/api/user/?groupID=${props.groupID}&membershipType=admin&page=1&id=${props.userID}`,
	}),

	success: (response) => response.data.users.length > 0,
});

export const GetUserInformation = CreateProcess({
	method: "GET",
	name: "GetUserInformation",
	type: "USERS:GETSINGLE",

	request: (props) => {
		const userID = get(props, ["params", "userID"], props.userID);
		return {
			url: `/api/v0.1/users/${userID}/`,
		};
	},

	success: (response) => fromJS(response.data),
});

export const PersonInput = CreateProcess({
	method: "GET",
	name: "PersonInputSearch",
	type: "USERS:SEARCH.INPUT",

	request: (props) => {
		const filterQueryString = props.filters ? serializeObject(props.filters) : "";
		const limitQueryString = props.limit ? `limit=${props.limit}` : "";

		return {
			url: `/api/user/?q=${props.query}&${filterQueryString}&${limitQueryString}`,
		};
	},

	success: (response) => {
		const employees = List().withMutations((mutable) => {
			response.data.users.forEach((user) => {
				mutable.push(Map({ id: user._id, name: user.name }));
			});
		});

		return employees;
	},
});

export const DirectReportsCount = CreateProcess({
	method: "GET",
	name: "GetDirectReportsCount",
	type: "USERS:DIRECTREPORTS.COUNT",

	request: (props) => ({
		url: `/api/user/count/?manager=${props.managerID}`,
	}),

	success: (response) => response.data.count,
});

export const getMe = CreateProcess({
	method: "GET",
	name: "GetMe",
	type: "USERS:ME",

	request: () => ({
		url: "/api/me/",
	}),

	success: (response) => fromJS(response.data),
});

export const GetIsChainOfCommand = CreateProcess({
	method: "GET",
	name: "GetIsChainOfCommand",
	type: "USERS:GET_CHAIN_OF_COMMAND",

	request: (props) => ({
		url: `/chain-of-command/${props.params.viewedUserID}`,
	}),

	success: (response) => response.data,
});

export const SearchEmployee = CreateProcess({
	method: "GET",
	name: "SearchEmployee",
	type: "USERS:SEARCH_EMPLOYEE",

	request: (props) => {
		const queryParams = serializeObject(props.params);
		return {
			url: `/api/employee-search/?${queryParams}`,
		};
	},

	success: (response) => response.data,
});

export const GetUserGustoData = CreateProcess({
	method: "GET",
	name: "GetUserGustoData",
	type: "USERS:GET_GUSTO_DATA",

	request: () => ({
		url: "/api/user/gusto/",
	}),

	success: (response) => response.data,
});
